export const useResources = (resourceListDSL) => {
    return Object.values(resourceListDSL).reduce((resources, resource) => (Object.assign(Object.assign({}, resources), { [resource.name]: resource })), {});
};
